import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button, Chip, FormControl, InputLabel, MenuItem, Paper, Select,
  Table, TableBody, TableCell, TableHead, TableRow, Typography, makeStyles
} from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles(theme => ({
  content: { padding: theme.spacing(2), overflowY: "auto" },
  filters: { padding: theme.spacing(2), display: "flex", gap: 12, marginBottom: theme.spacing(2) },
  filter: { minWidth: 180 },
  overdue: { color: theme.palette.error.main, fontWeight: 700 },
  actions: { display: "flex", gap: 6 }
}));

const FollowUps = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const [tasks, setTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [status, setStatus] = useState("pending");
  const [userId, setUserId] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get("/follow-ups", { params: { status, userId: userId || undefined } });
      setTasks(data);
    } catch (err) { toastError(err); }
  };

  useEffect(() => {
    if (user.profile === "admin") api.get("/users").then(({ data }) => setUsers(data.users)).catch(toastError);
  }, []);
  useEffect(() => { load(); }, [status, userId]);

  const update = async (task, nextStatus) => {
    try {
      await api.put(`/follow-ups/${task.id}`, { status: nextStatus });
      load();
    } catch (err) { toastError(err); }
  };

  return <MainContainer>
    <MainHeader><Title>Agenda de retornos</Title></MainHeader>
    <div className={classes.content}>
      <Paper variant="outlined" className={classes.filters}>
        <FormControl variant="outlined" size="small" className={classes.filter}>
          <InputLabel>Status</InputLabel>
          <Select value={status} onChange={event => setStatus(event.target.value)} label="Status">
            <MenuItem value="pending">Pendentes</MenuItem>
            <MenuItem value="completed">Concluídos</MenuItem>
            <MenuItem value="cancelled">Cancelados</MenuItem>
          </Select>
        </FormControl>
        {user.profile === "admin" && <FormControl variant="outlined" size="small" className={classes.filter}>
          <InputLabel>Atendente</InputLabel>
          <Select value={userId} onChange={event => setUserId(event.target.value)} label="Atendente">
            <MenuItem value="">Todos</MenuItem>
            {users.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)}
          </Select>
        </FormControl>}
      </Paper>
      <Paper variant="outlined">
        <Table size="small">
          <TableHead><TableRow><TableCell>Retorno</TableCell><TableCell>Contato</TableCell><TableCell>Responsável</TableCell><TableCell>Observação</TableCell><TableCell>Status</TableCell><TableCell>Ações</TableCell></TableRow></TableHead>
          <TableBody>{tasks.map(task => {
            const overdue = task.status === "pending" && new Date(task.dueAt) < new Date();
            return <TableRow key={task.id}>
              <TableCell className={overdue ? classes.overdue : undefined}>{new Date(task.dueAt).toLocaleString("pt-BR")}</TableCell>
              <TableCell>{task.ticket?.contact?.name}<Typography variant="caption" display="block">{task.ticket?.contact?.number}</Typography></TableCell>
              <TableCell>{task.assignedUser?.name}</TableCell>
              <TableCell>{task.note}</TableCell>
              <TableCell><Chip size="small" color={overdue ? "secondary" : "default"} label={overdue ? "Atrasado" : task.status} /></TableCell>
              <TableCell><div className={classes.actions}>
                <Button size="small" onClick={() => history.push(`/tickets/${task.ticketId}`)}>Abrir</Button>
                {task.status === "pending" && <Button size="small" color="primary" onClick={() => update(task, "completed")}>Concluir</Button>}
                {task.status === "pending" && <Button size="small" onClick={() => update(task, "cancelled")}>Cancelar</Button>}
              </div></TableCell>
            </TableRow>;
          })}</TableBody>
        </Table>
      </Paper>
    </div>
  </MainContainer>;
};

export default FollowUps;
